import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tt.css';

function Kalshi() {
  const navigate = useNavigate();

  // Image placeholders – place actual files in /public and keep or change these names
  const kalshiOverview = process.env.PUBLIC_URL + '/kalshi2.png';
  const kalshiFlow = process.env.PUBLIC_URL + '/kalshi4.png';
  const kalshi3 = process.env.PUBLIC_URL + '/kalshi3.png';
  const kalshi1 = process.env.PUBLIC_URL + '/kalshi1.png';

  const [modalImage, setModalImage] = useState(null);

  const openModal = (image) => {
    setModalImage(image);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <div className="TripTunes">
      <div className="middle-column">
        <h1>Kalshi Trading System</h1>
        <h3>What is this project?</h3>
        <p>
          A full-stack trading operation built on top of Kalshi&apos;s event contracts. This project
          focuses on turning raw prediction markets into a live, observable system of bots, risk
          controls, and dashboards that you can run from a desktop setup or your phone.
        </p>

        <img
          src={kalshiOverview}
          alt="Kalshi desktop overview UI"
          onClick={() => openModal(kalshiOverview)}
        />

        <h3>Live Portfolio Oversight</h3>
        <p>
          Real-time visualization of Cash Balance ($58.91), Portfolio Value ($2.54), and Total
          Balance ($61.45), paired with an instant breakdown of the 15+ open positions across the
          exchange.
        </p>

        <h3>Watchlist &amp; Order Management</h3>
        <p>
          Integrated a resting order and watchlist view to monitor diverse event contracts, from
          SpaceX Starship launches to Denver weather patterns and IPO dates.
        </p>

        <img src={kalshiFlow} alt="Active bots and portfolio view" onClick={() => openModal(kalshiFlow)} />

        <h3>Active Bot Monitoring</h3>
        <p>
          A dedicated dashboard to track running bots in real-time. Each bot card displays live
          order-book depth (YES/NO bids), current status (Warmup, Active, or Waiting for Liquidity),
          and the specific strategy currently being deployed.
        </p>

        <img
          src={kalshi1}
          alt="Autotrading bots and prefix/ticker system"
          onClick={() => openModal(kalshi1)}
        />

        <h3>Responsive Control</h3>
        <p>
          Whether on a desktop at home or via a mobile device on the go, the interface provides full
          operational control—allowing for &quot;Bulk Adds,&quot; account refreshes, and individual
          bot termination from anywhere in the world.
        </p>

        <img
          src={kalshi3}
          alt="Kalshi mobile flow and controls"
          onClick={() => openModal(kalshi3)}
        />



        <h3>Technical Stack</h3>
        <p>
          <h4>Backend: Python, FastAPI, WebSockets, Cryptography (RSA-PSS), Multithreading,
          Requests/Session pooling.</h4>
        </p>
        <p>
          <h4>Frontend: React, Responsive Web Design.</h4>
        </p>
        <p>
          <h4>Financial Tech: Algorithmic Trading, Order Book Management, Risk Management,
          Prediction Markets.</h4>
        </p>

        <button onClick={() => navigate('/')}>Back to Homepage</button>
        <br></br>
        <br></br>
      </div>

      {modalImage && (
        <div className="modal" onClick={closeModal}>
          <span className="close" onClick={closeModal}>
            &times;
          </span>
          <img className="modal-content" src={modalImage} alt="Modal" />
        </div>
      )}
    </div>
  );
}

export default Kalshi;
